import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export function Team({ app, onDone }) {
  const owner = app.my_role === "owner";
  const [c, setC] = useState({ username: "", role: "viewer" });
  const [to, setTo] = useState("");
  const run = async (fn, msg) => { try { await fn(); toast.success(msg); onDone(); } catch (err) { toast.error(formatApiError(err)); } };
  return (
    <section className="panel space-y-4 p-6" data-testid="dev-team">
      <p className="eyebrow">Team & ownership</p>
      <p className="text-sm text-slate-300">Owner: <b>@{app.owner?.username}</b></p>
      <ul className="space-y-1 text-sm">
        {app.collaborators.map((m) => (
          <li key={m.user_id} className="flex items-center justify-between gap-2 text-slate-300" data-testid={`dev-collaborator-${m.user_id}`}>
            <span>@{m.user?.username} · <span className="font-mono text-xs uppercase text-slate-500">{m.role}</span></span>
            {owner && <button className="text-xs text-red-300" onClick={() => run(() => api.delete(`/developer/apps/${app.app_id}/collaborators/${m.user_id}`), "Removed")} data-testid={`dev-collaborator-remove-${m.user_id}`}>Remove</button>}
          </li>
        ))}
      </ul>
      {owner && app.status !== "revoked" && <>
        <form className="flex flex-wrap gap-2" onSubmit={(e) => { e.preventDefault(); run(() => api.post(`/developer/apps/${app.app_id}/collaborators`, c), "Collaborator saved"); }} data-testid="dev-collaborator-form">
          <input className="field w-44" aria-label="Collaborator username" placeholder="username" value={c.username} onChange={(e) => setC({ ...c, username: e.target.value })} data-testid="dev-collaborator-username" />
          <select className="field w-auto" aria-label="Collaborator role" value={c.role} onChange={(e) => setC({ ...c, role: e.target.value })} data-testid="dev-collaborator-role">
            <option value="viewer">Viewer (usage & metadata)</option><option value="maintainer">Maintainer (credentials & settings)</option></select>
          <button className="btn-outline" disabled={!c.username} data-testid="dev-collaborator-add">Add</button>
        </form>
        {app.pending_transfer ? (
          <p className="text-sm text-copper-300" data-testid="dev-transfer-pending">Ownership offered to @{app.pending_transfer.user?.username} until {app.pending_transfer.expires_at.slice(0, 10)}.
            <button className="ml-2 underline" onClick={() => run(() => api.post(`/developer/apps/${app.app_id}/transfer/cancel`), "Offer cancelled")} data-testid="dev-transfer-cancel">Cancel</button></p>
        ) : (
          <form className="flex flex-wrap gap-2" onSubmit={(e) => { e.preventDefault(); window.confirm(`Offer ownership to @${to}? You become a maintainer once they accept.`) && run(() => api.post(`/developer/apps/${app.app_id}/transfer`, { username: to }), "Ownership offered"); }} data-testid="dev-transfer-form">
            <input className="field w-44" aria-label="New owner username" placeholder="new owner username" value={to} onChange={(e) => setTo(e.target.value)} data-testid="dev-transfer-username" />
            <button className="btn-outline" disabled={!to} data-testid="dev-transfer-submit">Transfer ownership</button>
          </form>
        )}
      </>}
    </section>
  );
}
